import type { ReactNode } from 'react';
import type { color } from 'types/shared/worlds';
import type { TracingConfig } from 'utils/amplitude/amplitude.types';

export interface RadioGroupsProps {
  type: 'default' | 'inline' | 'block';
  legendLabel?: string;
  data: {
    id: string | number | boolean;
    title: string | ReactNode;
    description?: string;
    InfoComponent?: React.FC;
    checked?: boolean;
    disabled?: boolean;
    onClick?: () => any;
  }[];
  onChange: (val: string) => void | undefined;
  labelClassNames?: string;
  inputClassNames?: string;
  className?: string;
  tracing?: TracingConfig;
  color?: color;
  idPrefix?: string;
  descriptionClassNames?: string;
  getOptionContainerClasses?: (
    meta: { checked: boolean; disabled: boolean },
    props: { borderTheme: string },
  ) => string;
}

type CustomRadioGroupsTypeMap = Record<
  RadioGroupsProps['type'],
  {
    inlineClasses: string;
  }
>;

export const customRadioGroupsTypeMap: CustomRadioGroupsTypeMap = {
  default: {
    inlineClasses: '',
  },
  inline: {
    inlineClasses: 'sm:flex sm:items-center sm:space-y-0 sm:space-x-10',
  },
  block: {
    inlineClasses: '',
  },
};
